export {default} from './PeopleData';
